import { getContext } from '@/context';
import { getTotalCredits } from '@/types';

import type { CreditsResponse } from '@/types';

const getCredits = async () => {
  await getContext().monetization.updateCredits();
  const credits =
    (await getContext().monetization.credits.getState()) as CreditsResponse;

  return getTotalCredits(credits);
};

export { getCredits };
